<template>
  <div
    :class="`lowcode-render-container ${
      renderType === 'preview' ? 'preview' : ''
    }`"
    v-if="currentPageDsl.pageId">
    <component
      v-for="item in currentPageDsl.dslContent"
      :key="item.cid"
      :data="item"
      :is="components[`${item.type}Component`]"></component>
  </div>
</template>

<script setup>
import { computed, onMounted, ref, watch, onUnmounted } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import { showToast } from 'vant'
import useWechat from '@/hooks/useWechat'
import useQrCode from '@/hooks/useQrCode'
import useTrack from '@/hooks/useTrack'
import { setTitle } from '@/utils/index'

const route = useRoute()
const store = useStore()
const { wechatAuth } = useWechat()
const { fetchSamePeerStatus } = useQrCode()
const { track } = useTrack()
const currentPageDsl = computed(() => store.state.currentPageDsl)
const commonDsl = computed(() => store.state.dslData.commonDsl)
const renderType = computed(() => store.state.renderType)
const { pageType, id, subId } = route.params
const components = ref({})
const userInfo = computed(() => store.state.userInfo)

const timecount = ref(0)
let timer = null

// 页面滑动触底
const scrollTrack = () => {
  let hitted = false
  document.addEventListener('scroll', () => {
    if (hitted) return
    const scrollTop =
      document.documentElement.scrollTop || document.body.scrollTop
    const scrollHeight =
      document.documentElement.scrollHeight || document.body.scrollHeight
    const clientHeight =
      document.documentElement.clientHeight || window.innerHeight
    if (scrollTop + clientHeight + 50 >= scrollHeight) {
      hitted = true
      track('hit_ad_bottom', {})
    }
  })
}

// 页面停留计时
const initTimer = () => {
  if (timer) clearInterval(timer)
  timer = setInterval(() => {
    timecount.value = timecount.value + 1
  }, 1000)

  // 离开页面埋点
  window.addEventListener('pagehide', () => {
    if (timer) clearInterval(timer)
    if (timecount.value >= 3)
      track('exit_ad_page', { stay_time: timecount.value })
  })
}

// 根据页面type渲染某套组件（推广/物料/运营）
onMounted(async () => {
  // vaster预览模式
  if (id === 'preview' || route.query?.preview)
    store.commit('setRenderType', { renderType: 'preview' })
  if (id === 'preview') {
    // store.commit('setRenderType', { renderType: 'preview' })
    window.addEventListener(
      'message',
      (msg) => {
        if (msg.data?.dslContent) {
          store.commit('setCurrentPageDsl', {
            pageId: 'preview',
            dslContent: msg.data.dslContent,
          })
        }
      },
      false
    )
  } else {
    // 接口获取页面信息
    try {
      await store.dispatch('fetchPageInfo', { key: route.query.pageKey || '' })
      // 锁定当前展示页面
      await store.commit('getPageDslByPageId', { id, subId })
    } catch (err) {
      showToast('获取页面数据失败')
      return
    }
    // 更改页面标题
    if (currentPageDsl.value?.pageTitle) setTitle(currentPageDsl.value?.pageTitle)
  }

  // 页面滑动触底埋点
  scrollTrack()
  // 初始化页面计时器
  initTimer()

  // 微信授权
  if (commonDsl.value?.env === 0 && commonDsl.value?.needAuth) {
    // 推广页面
    await wechatAuth()
  }else if(commonDsl.value?.currentEnv === 'wechat' && commonDsl.value?.needAuth) {
    // 运营页面
    if(!window.location.search.includes("xinstall_unionid") || !window.location.search.includes("xinstall_username")) {
      await wechatAuth()
      window.location.href =  `${window.location.href}&xinstall_unionid=${userInfo.value?.unionid}&xinstall_username=${userInfo.value?.username || userInfo.value?.userData?.username}`
    }
  }

  // 进入页面埋点
  track('enter_ad_page', {})

  // 防同行逻辑 将信息保存到本地中
  await fetchSamePeerStatus()

  // 组件引入
  components.value = (
    await import(`@/components/${pageType}Components/index`)
  ).default
})

onUnmounted(() => {
  // 页面退出时清除计时器
  if (timer) clearInterval(timer)
})

watch(
  () => route.params,
  async (val) => {
    const { id, subId } = val
    store.commit('getPageDslByPageId', { id, subId })
    // 初始化页面计时器
    initTimer()
  }
)
</script>

<style lang="stylus" scoped>
.lowcode-render-container {
  &.preview {
    pointer-events: none;
  }
}
</style>
